type Props = {
  record: any
};

const ValidateRule = (props: Props) => {
  const errors = { segment_attributes: null };

  if (props.record &&
    props.record.segment_attributes &&
    props.record.segment_attributes.filter_deal_id_attributes &&
    props.record.segment_attributes.filter_deal_id_attributes.values.length > 40
  ) {
    errors.segment_attributes = { filter_deal_id_attributes: { values: ['Cannot exceed 40 characters'] } };
  }

  return errors;
}

export default ValidateRule;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/AdQuality/Helpers/ValidateRule.tsx